// ./src/pages/private/EventSchedulePage/slotSpeakerRules.ts
//
// The rules behind the Schedule drawer (the "Speakers" picker and the description format), on their own so `check-slot-speakers` can RUN them —
// import-free on purpose (the service layer reads Vite's env and cannot load outside the browser).

/**
 * The roles a session may show: the event's own TEAM — exactly what the SERVER accepts (`EventTimeSlotCore` →
 * `EVENT_CREW_ROLES`). ⚠ Not the app's `TEAM_ROLES`: that one also holds an act's touring `crew` and `entourage`, who
 * belong to an artist booking — offering them would let a host pick someone the save then refuses. Mirrors the blocks
 * package's `TEAM_ROLES` (itself the server's list); the guard pins the two equal.
 */
export const SESSION_PEOPLE_ROLES: readonly string[] = ['host', 'co_host', 'organizer', 'staff', 'volunteer', 'vendor', 'speaker', 'performer', 'other'];

/**
 * The picker reports the new SET; the session keeps an ORDER. People already picked keep their places, new picks go to
 * the END — so the list under the picker (and the public schedule) keeps the order people were added in.
 */
export const appendPicks = (current: string[], nextSet: string[]): string[] => [
  ...current.filter((id) => nextSet.includes(id)),
  ...nextSet.filter((id) => !current.includes(id)),
];

/** Moved to `utils/textFormatCarry.ts` (the page editor's text block uses it too); kept here under its old name. */
export { carryTextOver as carryDescriptionOver } from '../../../utils/textFormatCarry';
